import React from 'react'

export default function Section({children}) {
  return (
    <>
        {children}
    </>
  )
}
